import axios from 'axios'
import Vue from 'vue'

// initial state
const state = {
  permissions: [],
  expires: null,
  claims: {},
  profile: {},
  profiles: {},
  users: {},
  invitations: {},
  customer: {},
  isLoggedIn: false
}

// getters
const getters = {
  userId() {
    return state.claims.user_id
  },
  pnoUser() {
    return state.claims.pno
  },

  profile: (state) => {
    return state.profile
  },
  users: (state) => {
    return Object.values(state.users)
      .filter(item => item)
  },

  invitations: (state) => {
    return Object.values(state.invitations)
      .filter(item => item)
  }
}

// actions
const actions = {
  async loadUser({ commit }) {
    const response = await axios.get(window.envConfig.API_BASEURL + '/api/user', { withCredentials: true });


    commit('setPermissions', response.data.permissions)
    commit('setExpires', response.data.expires)
    commit('setClaims', response.data.claims)
    commit('setIsLoggedIn', true)
    commit('setProfile', response.data.profile ? response.data.profile : {
      name: response.data.claims.name,
      email: response.data.claims.sub,
      avatarUrl: response.data.claims.avatar
    })
    return response.data
  },
  autoLogout({ commit }, callback) {
    const timeout = state.expires - Math.floor(Date.now() / 1000)
    // Auto logout after session expires.
    setTimeout(function () {
      if (state.expires <= Math.floor(Date.now() / 1000)) {
        console.log("Access token expired")
        callback()
      }
    }, timeout * 1000)

    // Auto logout after session expires through polling.
    // The above handler might not be triggered, due to browser sleep etc.
    //
    // @todo will this polling method suffice? Can we skip the above timeout
    //       handler?
    setInterval(function () {
      // console.log("Checking: " + Math.floor(Date.now() / 1000))
      if (state.expires <= Math.floor(Date.now() / 1000)) {
        console.log("Access token expired")
        callback()
      }
    }, 5 * 1000)
  },
}

// mutations
const mutations = {
  setPermissions(state, permissions) {
    state.permissions = permissions
  },

  setExpires(state, expires) {
    state.expires = expires
  },

  setTimeoutHandler(state, timeoutHandler) {
    state.timeoutHandler = timeoutHandler
  },

  setCustomer(state, customer) {
    state.customer = customer
  },

  setClaims(state, claims) {
    state.claims = claims

    const lastUser = Vue.localStorage.get('userId', '')
    if (lastUser !== claims.user_id) {
      Vue.localStorage.clear()
    }

    Vue.localStorage.set('userId', claims.user_id)
  },

  setProfile(state, profile) {
    profile.firstname = profile.name ? profile.name.replace(/ .*/, '') : ''
    state.profile = {...state.profile, ...profile}
  },

  setProfileData(state, profile) {
    const current = state.profiles[profile.userId] ? state.profiles[profile.userId] : {}
    Vue.set(state.profiles, profile.userId, Object.assign({}, current, profile))
  },

  setUsers(state, users) {
    for (let user of users) {
      Vue.set(state.users, user.userId, user)
    }
  },
  setIsLoggedIn(state, newState) {
    state.isLoggedIn = newState
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}